import { Injectable, Optional } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { of } from 'rxjs';
import { AbstractAlertService } from './alert-service.base';
import { AddErrorAlert, AddInfoAlert, AddSuccessAlert, ClearAlerts } from './alert.actions';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface AlertStateModel {}

@State<AlertStateModel>({
  name: 'alert',
  defaults: {},
})
@Injectable()
export class AlertStateModule {
  constructor(@Optional() private _abstractAlertService: AbstractAlertService) {}

  @Action(AddInfoAlert)
  public addInfoAlert(_ctx: StateContext<AlertStateModel>, { payload }: AddInfoAlert) {
    const { alert } = payload;
    return this._abstractAlertService ? this._abstractAlertService.showInfoAlert(alert.message, alert.duration) : of();
  }

  @Action(AddSuccessAlert)
  public addSuccessAlert(_ctx: StateContext<AlertStateModel>, { payload }: AddSuccessAlert) {
    const { alert } = payload;
    return this._abstractAlertService ? this._abstractAlertService.showSuccessAlert(alert.message, alert.duration) : of();
  }

  @Action(AddErrorAlert)
  public AddErrorAlert(_ctx: StateContext<AlertStateModel>, { payload }: AddErrorAlert) {
    const { alert } = payload;
    return this._abstractAlertService ? this._abstractAlertService.showErrorAlert(alert.message, alert.duration) : of();
  }

  @Action(ClearAlerts)
  public clearAlerts() {
    return this._abstractAlertService ? this._abstractAlertService.clearAlerts() : of();
  }
}
